<template>
    <v-main>
      <CollectionsHero />
      <CollectionsChat/>
      <CollectionsEngagement />
      <AiChat />
      <CollectionsCustomerPortals />
      <CollectionsPaymentPortals />
      <CollectionsCalendar />
      <CollectionsLanguage />
      <CollectionsSegments />
      <RequestDemo msg="Smarter collections, better outcomes."/>
    </v-main>
  </template>
  
<script>
import CollectionsHero from './CollectionsHero.vue'
import AiChat from './AiChat.vue'
import CollectionsEngagement from './CollectionsEngagement.vue'
import CollectionsCustomerPortals from './CollectionsCustomerPortals.vue'
import CollectionsPaymentPortals from './CollectionsPaymentPortals.vue'
import CollectionsChat from './CollectionsChat.vue'
import CollectionsCalendar from './CollectionsCalendar.vue'
import CollectionsLanguage from './CollectionsLanguage.vue'
import CollectionsSegments from './CollectionsSegments.vue'
import RequestDemo from './RequestDemo.vue'
export default {
  name: 'CollectionsPage',
  components: {
      CollectionsHero,
      AiChat,
      CollectionsEngagement,
      CollectionsCustomerPortals,
      CollectionsPaymentPortals,
      CollectionsChat,
      CollectionsCalendar,
      CollectionsLanguage,
      CollectionsSegments,
      RequestDemo
  },
}
</script>
  